import React from 'react';
import { Skeleton, Typography } from 'fronton-react';
import { formatNumber } from 'common/utils/format-number';
import { BonusLogo } from '@fronton/icons-react/logos';
import { useBreakpoints } from 'common/hooks';
import { UserMenuLoyaltyPointsWrapper } from './styles';
import { ErrorWithStatus } from 'api/error-with-status';

interface IUserMenuLoyaltyPoints {
  points: number | null;
  fetchLoyaltyPointsError: ErrorWithStatus | null;
  fetchLoyaltyPointsLoading: boolean;
}

export const QA_USER_MENU_BONUS_LOGO = 'user-menu-bonus-logo';
const QA_USER_MENU_LOYALTY_POINTS = 'user-menu-loyalty-points';
export const QA_USER_MENU_LOYALTY_POINTS_SKELETON = 'user-menu-loyalty-points-skeleton';

export const UserMenuLoyaltyPoints: React.FC<IUserMenuLoyaltyPoints> = ({
  points,
  fetchLoyaltyPointsError,
  fetchLoyaltyPointsLoading,
}) => {
  const { mobile, tablet } = useBreakpoints() || {};

  if (!(mobile || tablet) || fetchLoyaltyPointsError) {
    return <></>;
  }

  if (fetchLoyaltyPointsLoading) {
    return (
      <UserMenuLoyaltyPointsWrapper>
        <Typography variant="mini" size="overline" data-qa={QA_USER_MENU_LOYALTY_POINTS_SKELETON}>
          <Skeleton size="body_long" width="32px" height="13px" variant="s" />
        </Typography>
        <Skeleton width="12px" height="12px" variant="control" roundingSize="circle" />
      </UserMenuLoyaltyPointsWrapper>
    );
  }

  if (points !== null) {
    return (
      <UserMenuLoyaltyPointsWrapper>
        <Typography
          variant="mini"
          size="overline"
          color={points < 0 ? 'attention-primary' : 'text-primary'}
          data-qa={QA_USER_MENU_LOYALTY_POINTS}
        >
          {formatNumber(points)}
        </Typography>
        <BonusLogo data-qa={QA_USER_MENU_BONUS_LOGO} width={12} height={12} />
      </UserMenuLoyaltyPointsWrapper>
    );
  }

  return <></>;
};
